module.exports = __webpack_public_path__ + "img/Kochen & Genuss.2374e1e4.jpg";